// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1YqHt","filesListContainer":"PosDisputesFiles_filesListContainer__3zg2D","filesButton":"PosDisputesFiles_filesButton__3OVpT"};